import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { ARTICLES } from "@/data/articles";

export default function BlogTeaser() {
  return (
    <section
      id="ratgeber"
      data-testid="blog-teaser-section"
      className="border-t border-line bg-sand-deep py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="text-xs uppercase tracking-[0.3em] text-clay"
              data-testid="blog-teaser-eyebrow"
            >
              02 — Ratgeber
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="mt-6 font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl"
              data-testid="blog-teaser-title"
            >
              Wissen für Ihre{" "}
              <span className="italic text-clay">Auswanderung</span>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="mt-6 text-base leading-relaxed text-ink-muted"
              data-testid="blog-teaser-intro"
            >
              Ehrliche Leitfäden aus der Praxis: Gründung, Visum und Ankommen in
              Florida – kostenlos und auf Deutsch.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.3 }}
            >
              <Link
                to="/ratgeber"
                data-testid="blog-teaser-all-link"
                className="group mt-10 inline-flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-clay"
              >
                Alle Artikel lesen
                <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </Link>
            </motion.div>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ul className="border-t border-line" data-testid="blog-teaser-list">
            {ARTICLES.map((article, index) => (
              <motion.li
                key={article.slug}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: index * 0.08 }}
                className="border-b border-line"
                data-testid={`blog-card-${article.slug}`}
              >
                <Link
                  to={`/ratgeber/${article.slug}`}
                  data-testid={`blog-card-link-${article.slug}`}
                  className="group block py-10 transition-colors hover:bg-sand"
                >
                  <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em] text-ink-muted">
                    <span className="text-clay">{article.category}</span>
                    <span className="inline-flex items-center gap-1.5">
                      <Clock className="h-3.5 w-3.5" />
                      {article.readingTime}
                    </span>
                  </div>
                  <h3 className="mt-4 font-serif text-2xl tracking-tight text-ink transition-colors group-hover:text-clay sm:text-3xl">
                    {article.title}
                  </h3>
                  <p className="mt-3 max-w-2xl text-sm leading-relaxed text-ink-muted md:text-base">
                    {article.description}
                  </p>
                </Link>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
